// extracted by mini-css-extract-plugin
export default {"componentWrapper":"RemoveExport_componentWrapper__qf0kI","actions":"RemoveExport_actions__kFZ7y"};